/**
 * Themed stack navigator for the route groups that render whole pages, as
 * opposed to widgets embedded in a host page.
 */

import { useTheme } from '@repo/theme';
import { getNavigationThemes } from 'component/navigation/theme';
import { Stack } from 'expo-router';
import { ThemeProvider } from 'expo-router/react-navigation';
import { useMemo } from 'react';

export function AppStack({ children }: { children?: React.ReactNode }) {
    const tokens = useTheme();
    const { defaultNavigationTheme } = useMemo(() => getNavigationThemes(tokens), [tokens]);

    return (
        <ThemeProvider value={defaultNavigationTheme}>
            <Stack screenOptions={{ headerShown: false }}>{children}</Stack>
        </ThemeProvider>
    );
}
